import LicenseDetails from './LicenseDetails';

export default LicenseDetails;
